'use strict'

export default (mockAxios) => {
  // 自分が代理指定しているユーザー一覧情報（max2人）を取得
  mockAxios.onGet(`/admin`).reply(200, {
    'success': true,
    'data': {
      'usercount': 170,
      'groupcount': 30,
      'pwdpolicy': {
        'pwdlimit': null,
        'login_failures_permitted': null
      },
      'attachsize': {
        'attachsize': '5 MB'
      },
      'license': {
        'formatted_contract_count': '10,000',
        'formatted_bcard_usage': '570', // V2で追加
        'formatted_bcard_count': '56,780', // V2で追加
        'contract_input': '1',
        'formatted_judgement_date': '2018/10/01',
        'bcard_usage': 57
      },
      'mblogin': {
        'mbcompanycodesave': '1',
        'mbloginidsave': '1',
        'mbloginpwdsave': '0',
        'mbloginsidterm': 59940
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/adminRepositoryMock.js